import React from "react";
import { ReactComponent as ConnectIcon } from "../../../img/trade-history/wallet.svg";
import { RainbowKitWalletButton } from "../../../components/Header/ConnectWallet/RainbowKitWalletButton";
import styled from "@emotion/styled";
import { NoTradesDisplayContainer } from "./NoTradesDisplayContainer";
import { css } from "@emotion/react";
import { useIsMobile } from "hooks/useDeviceType";

export const ConnectWalletCTA: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <NoTradesDisplayContainer isConnectWallet={true}>
      <IconContainer>
        <ConnectIcon width={100} height={82} />
      </IconContainer>
      <ConnectWalletText>Connect your wallet to start trading.</ConnectWalletText>
      {/* TODO: Style RainbowKitWalletButton to match design I think it impacts /trade in the header so needs to be done at the same time as when we move the new sidebar to /trade */}
      <RainbowKitWalletButton css={connectWalletCss(isMobile)} />
    </NoTradesDisplayContainer>
  );
};

// Sub-components

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  height: 130px;
`;

const ConnectWalletText = styled.h2`
  font-size: ${props => props.theme.fontSize["6"]};
  line-height: ${props => props.theme.lineHeights[4]};
  text-align: center;
`;

// Helpers

const connectWalletCss = (isMobile: boolean) => css`
  width: ${isMobile ? 200 : 220}px;
  border-radius: 14px;
  padding: 10px 14px 10px 8px;
  height: 40px;

  svg {
    width: 20px;
    height: 20px;
  }
`;
